import Typography from "@mui/material/Typography";

function RecordRemovedPage() {
	return (
		<div className="flex flex-col bg-white justify-center w-full h-full md:overflow-hidden hide-scrollbar">
			<div className="h-full w-full flex md:flex-row flex-col overflow-hidden hide-scrollbar">
				<div className="flex h-full w-full items-center justify-center md:basis-6/12 p-[80px_20px] md:p-[40px_80px]">
					<div className="w-full max-w-320 text-center">
						<img
							className="mx-auto h-[40px] w-[110.86px]"
							src="assets/img/checkout-logo.svg"
							alt="logo"
						/>

						<Typography className="mt-32 text-2xl font-extrabold leading-tight tracking-tight">
							This pet record has been removed from the Peeva registry. You will no longer receive notifications about this pet.
						</Typography>
						<Typography
							className="mt-32 text-xl font-medium"
							color="text.secondary"
						>
							If you removed this record by mistake, please contact{" "}
							<a className="text-bold text-peeva-blue" href="mailto:support@peeva.co">
								support@peeva.co
							</a>
						</Typography>
					</div>
				</div>

				<div className="md:max-h-[100vh] flex justify-between flex-col h-full w-full md:pb-0 md:w-1/2 overflow-hidden pb-0 px-0 sm:shadow bg-no-repeat bg-top object-fill md:bg-center bg-contain md:bg-cover">
					<img className="object-fill" src="assets/img/signupIcon7.jpg" />
				</div>
			</div>
		</div>
	);
}

export default RecordRemovedPage;
